import {Injectable, SecurityContext} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {PRICE_PATTERN} from '../../requests/constants/request-details.constants';
import {SystemMessageComponent} from '../components/system-message/system-message.component';
import {ToastrService} from 'ngx-toastr';
import {DomSanitizer} from '@angular/platform-browser';

export const DEFAULT_DURATION = 10000;
export const DEFAULT_EXTENDED_DURATION = 2000;

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private toastr: ToastrService,
    private sanitizer: DomSanitizer) {
    this.toastr.toastrConfig.toastComponent = SystemMessageComponent;
    this.toastr.toastrConfig.autoDismiss = true;
    this.toastr.toastrConfig.positionClass = 'toast-bottom-left';
  }

  public getControlErrorMessage(errors: ValidationErrors): string {
    if (errors.required)  { return 'You must enter a value'; }
    if (errors.notEmpty)  { return 'You must enter a value'; }
    if (errors.minlength) { return `Minimum length is ${errors.minlength.requiredLength}`; }
    if (errors.maxlength) { return `Maximum length is ${errors.maxlength.requiredLength}`; }
    if (errors.max)       { return `Please enter value less than ${errors.max.max}`; }
    if (errors.min)       { return `The minimum value for this field is ${errors.min.min}`; }
    if (errors.unique)    { return `Value should be unique`; }
    if (errors.maxCalculation) { return `Please enter value so field ${errors.maxCalculation.fieldName
    } is less than ${errors.maxCalculation.max}`; }

    if (errors.pattern) {
      let message = 'Invalid value';
      if (errors.pattern.requiredPattern === String(PRICE_PATTERN))  {
        message = 'Please use numeric format XXXXXX.XXXXXX (ex. 999999.000000)';
      }
      return message;
    }

    if (errors.wpnError) {
      return 'Please recheck entered WPN';
    }

    if (errors.upcError) {
      return 'Please recheck entered Product UPC';
    }

    if (errors.email) {
      return 'Please enter a well-formed email address';
    }

    if (errors.notFound) {
      return 'No results found';
    }

    if (errors.userValidator) {
      return 'Please select user from dropdown list';
    }

    if (errors.printerInfoValidator) {
      return 'You must enter a value';
    }

    if (errors.packageIdTBDValidator) {
      return 'Package Id must be defined (no TBD)';
    }

    if (errors.productionQtyValidator) {
      return 'Production Qty must have a quantity in multiples of Master Case Size. Please re-enter quantity.';
    }

    if (errors.cardProductionQtyValidator) {
      return 'Production Qty must have a quantity in multiples of Case Size. Please re-enter quantity.';
    }

    return 'Invalid value';
  }

  public showSystemMessage(status: 'warning' | 'success' | 'error' | string, header?: string, body?: string | any, duration: number = DEFAULT_DURATION, extendedTimeoutDuration = DEFAULT_EXTENDED_DURATION, enableHtml = false): void {
    if(enableHtml) {
      body = this.sanitizer.bypassSecurityTrustHtml(
        this.sanitizer.sanitize(SecurityContext.NONE, body)
      );
    }
    this.toastr.show(body, header, {
      messageClass: status,
      closeButton: true,
      timeOut: duration,
      extendedTimeOut: duration !== 0 ? extendedTimeoutDuration : 0,
      disableTimeOut: duration !== 0 ? false : 'extendedTimeOut',
      tapToDismiss: true,
      progressBar: true,
      easeTime: 300,
    });
  }
}
